import {
  BusinessTarget,
  BusinessTargetConfig,
  Locale,
  Env,
  BusinessAppType,
} from '@shopee-user/global';
export { useTranslation, withTranslation } from '@shopee-user/i18n';

// Utils
export {
  isValidLanguage,
  getUserLanguage,
  setUserLanguage,
} from '../utils/language';
export {
  isWebBridgeSupported,
  getPlatformType,
  getAppType,
  PlatformType,
  AppType,
  fetchToBDataFromNative,
} from '@shopee/web-bridge-sdk';

const {
  getRealTimeMetricsReportDomain,
  appType: businessAppType,
} = BusinessTargetConfig[__BUSINESS_TARGET__ as BusinessTarget];

export const REAL_TIME_METRICS_REPORT_DOMAIN = getRealTimeMetricsReportDomain(
  __ENV__ as Env,
  __LOCALE__ as Locale
);

const config = {
  BUSINESS_TARGET: __BUSINESS_TARGET__ as BusinessTarget,
  ENV: __ENV__ as Env,
  LOCALE: __LOCALE__ as Locale,
  DEV: __DEV__,
  IS_LOCAL: __LOCAL__,
  REAL_TIME_METRICS_REPORT_DOMAIN:
    __DEV__ || __LOCAL__ ? '' : REAL_TIME_METRICS_REPORT_DOMAIN,
  BUSINESS_APP_TYPE: businessAppType as BusinessAppType,
};

export { config };

// Redux
export {
  InjectReducerContext,
  withInjectReducer,
} from '@shopee/with-inject-reducer';

export type { WithInjectReducerProps } from '@shopee/with-inject-reducer';

// GTM
export { Gtm } from './gtm';
